/* [Component: storesImport] */
import { AsOfDateStore } from '../components/AsOfDate/stores/AsOfDateStore.js';
import { ChartPeriodSelectionStore } from '../components/ChartPeriodSelection/stores/ChartPeriodSelectionStore.js';
import { DateSelectionStore } from '../components/DateSelection/stores/DateSelectionStore.js';
import { LineChartStore } from '../components/LineChart/stores/LineChartStore.js';
import { TStoreContext } from '../models/app/TStoreContext.js';

export function setupStoreContext(storeContext: TStoreContext) {
	/* [Component: stores] */
	storeContext.set('dateSelectionStore', new DateSelectionStore(storeContext, storeContext.manifest));
	storeContext.set('lineChartStore', new LineChartStore(storeContext, storeContext.manifest));
	storeContext.set('chartPeriodSelectionStore', new ChartPeriodSelectionStore(storeContext, storeContext.manifest));
	storeContext.set('asOfDateStore', new AsOfDateStore(storeContext, storeContext.manifest));
}
